import { useMemo } from 'react'
import { useGrowthbookFeature } from './useGrowthbook'
import { useFeatureIsOn } from '@growthbook/growthbook-react'
import storageService from '../services/storageService'

export const useIsInGameNavigationEnabled = () => {
  const { userIds } = useGrowthbookFeature(
    'fe_igp_in_game_bottom_navigation_test_users',
    { userIds: [] }
  )
  const isInGameNavigationEnabled = useFeatureIsOn(
    'fe_igp_is_in_game_bottom_navigation_enabled'
  )

  const isATestUser = useMemo(() => {
    const user = storageService.getUser()
    return userIds?.includes(user?.id)
  }, [userIds])

  const isEnabled = isInGameNavigationEnabled || isATestUser

  return isEnabled
}
